import React, { useState, useEffect, useRef } from 'react';

import 'ol/ol.css';

import { Map, View } from 'ol';
import GeoJSON from 'ol/format/GeoJSON';
import TileLayer from 'ol/layer/Tile';
import { Vector as VectorLayer } from 'ol/layer';
import Overlay from 'ol/Overlay';
import { Vector as VectorSource } from 'ol/source';
import OSM from 'ol/source/OSM';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';
import { fromLonLat } from 'ol/proj';
import { Point, MultiPolygon } from 'ol/geom';

import { Container } from "@mui/material";
import Page from "src/components/Page";
import * as C from "../map_utils/constants";
import Summary from './Summary';
import ReactDOMServer from 'react-dom/server';
import { GeoContext } from '../GeoContext'


export default function Pushpins() {
  const geoContext = React.useContext(GeoContext);
  const locationConfig = C.locationConfigs[geoContext.getLocation];

  const [selectedFeature, setSelectedFeature] = useState();
  const selectedFeatureRef = useRef();
  selectedFeatureRef.current = selectedFeature;

  const [map, setMap] = useState();
  const mapElement = useRef();
  const mapRef = useRef();
  mapRef.current = map;

  const pushpins = new VectorLayer({
    source: new VectorSource({
      format: new GeoJSON(),
      url: locationConfig.buildingPushpins
    }),
  });

  const fill = new Fill({
    color: 'rgba(255,255,255,0.4)'
  });
  const fillSelected = new Fill({
    color: 'rgba(255, 0, 0, 100)'
  })
  const stroke = new Stroke({
    color: '#3399CC',
    width: 1.25
  });

  const iconStyleDefault = new Style({
    image: new CircleStyle({
      fill: fill,
      stroke: stroke,
      radius: 5
    }),
    fill: fill,
    stroke: stroke
  });

  const iconStyleClick = new Style({
    image: new CircleStyle({
      fill: fillSelected,
      stroke: stroke,
      radius: 7
    }),
    fill: fillSelected,
    stroke: stroke
  });


  const buildingStyleDefault = new Style({
    stroke: new Stroke({
      color: 'rgba(0, 136, 136, 0.1)',
    }),
    fill: new Fill({
      color: 'rgba(0, 136, 136, 0.25)',
    }),
  });

  const structures = new VectorLayer({
    source: new VectorSource({
      format: new GeoJSON(),
      url: locationConfig.buildingStructures
    }),
    style: buildingStyleDefault
  });

  useEffect(() => {
    const container = document.getElementById('popup');
    const popupContent = document.getElementById('popup-content');
    const closer = document.getElementById('popup-closer');

    const overlay = new Overlay({
      element: container,
      autoPan: {
        animation: {
          duration: 250,
        },
      },
    });

    closer.onclick = function () {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    const selectFeature = (feature) => {
      feature.setStyle(iconStyleClick);
      setSelectedFeature(feature);
    }

    const unSelectFeature = () => {
      if (selectedFeatureRef.current) {
        if (selectedFeatureRef.current.getGeometry() instanceof Point) {
          selectedFeatureRef.current.setStyle(iconStyleDefault);
        }
        else if (selectedFeatureRef.current.getGeometry() instanceof MultiPolygon) {
          selectedFeatureRef.current.setStyle(buildingStyleDefault);
        }
        setSelectedFeature(undefined);
      }
    }

    const handleMapClick = (event) => {
      unSelectFeature();

      // get clicked coordinate using mapRef to access current React state inside OpenLayers callback
      // https://stackoverflow.com/a/60643670
      const feature = mapRef.current.forEachFeatureAtPixel(event.pixel, function (feature) {
        return feature;
      });

      if (feature && feature.values_) {
        selectFeature(feature);

        const htmlString = ReactDOMServer.renderToString(<Summary feature={feature} />)
        popupContent.innerHTML = htmlString;
        feature.setStyle(iconStyleClick);
        feature.setId('selected')
        overlay.setPosition(event.coordinate);
      }
      else {
        closer.click()
      }
    }

    const initialMap = new Map({
      target: mapElement.current,
      layers: [
        new TileLayer({
          source: new OSM(),
        }),
        structures,
        pushpins,
      ],
      overlays: [overlay],
      view: new View({
        center: fromLonLat(locationConfig.zoom_center),
        zoom: locationConfig.zoom_degree,
      }),
    });
    initialMap.on('click', handleMapClick)
    setMap(initialMap);
  }, []);


  return (
    <Page>
      <Container maxWidth="xl">
        <div>
          <div style={{ height: '70vh', width: '100%' }} ref={mapElement} className="map-container" />
          <div id="popup" className="ol-popup">
            <a href="#" id="popup-closer" className="ol-popup-closer"></a>
            <div id="popup-content"></div>
          </div>
        </div>
        {/* <Summary></Summary> */}
      </Container>
    </Page>
  );
}